export default __webpack_public_path__ + "static/media/large-arrow-left.1810c6ff.svg";